const PulsatingBadge = ({
  withBorder = false,
  badgeLabel = '',
  variant = 'first', // "first", "second", "third"
  onClick,
  isHide = false,
}) => {
  return (
    <div className="pb-container">
      <button className="pb-status-button" onClick={onClick}>
        <div className={['pb-badge', `pb-${variant}`, isHide ? 'pb-status-hidden' : '', withBorder ? `pb-${variant}-border pb-badge-border` : ''].join(' ')}>
          <div className={`pb-circle pb-${variant}-circle`} />
          {badgeLabel && <span className="pb-text">{badgeLabel}</span>}
        </div>
      </button>
    </div>
  );
};

export default PulsatingBadge;
